import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getLiscenseDetails } from 'redux/auth/authActions';
import { getLiscenseValidity, setLiscenseDetails } from 'redux/auth/authSlice';
import { useSignOut } from 'auth/useAuth';
import { addToSession, getFromStorage } from 'utils/storage';
import { liscenseExpired } from 'utils/constants';

const LICENSE_VALID = 'LICENSE_VALID';

export const Liscense = () => {
    const dispatch = useDispatch();
    const signout = useSignOut();

    const [intervalId, setIntervalId] = useState(null);
    const validity = useSelector(getLiscenseValidity);
    const [expiryDate, setExpiryDate] = useState();

    const getLiscenseInfo = () => {
        dispatch(getLiscenseDetails());
    };

    const clearPreviousInterval = () => {
        if (intervalId) {
            window.clearInterval(intervalId);
        }
    };

    const addNewInterval = () => {
        clearPreviousInterval();
        const newIntervalId = setInterval(() => {
            getLiscenseInfo();
        }, 60000);
        setIntervalId(newIntervalId);
    };

    const setExpiryMessage = () => {
        const { expiryDate } = validity;
        if (expiryDate === '-1') {
            setExpiryDate('No Expiry');
        } else {
            setExpiryDate(expiryDate);
        }
    };

    useEffect(() => {
        if (!validity) {
            const localLiscense = getFromStorage('liscense');
            if (localLiscense) {
                dispatch(setLiscenseDetails(localLiscense));
            } else {
                getLiscenseInfo();
            }
        }
        addNewInterval();

        return () => {
            clearPreviousInterval();
        };
    }, []);

    useEffect(() => {
        if (validity) {
            if (validity.validationStatus === LICENSE_VALID) {
                setExpiryMessage();
            } else {
                addToSession(liscenseExpired, true);
                signout();
            }
        }
    }, [validity]);

    // return <Typography
    // style={{marginLeft:'31px'}}> License Validity: {expiryDate}</Typography>;
};
